import { Collapse, Modal, Tab } from 'bootstrap';
window.bootstrap = { Collapse, Modal, Tab };

import { whenDocumentReady } from '../../../paws/assets/frontend/js/helper/documentready';
import { whenResize } from '../../../paws/assets/frontend/js/helper/resize';
import { wsForm } from '../../../paws/assets/frontend/js/helper/wsform';

whenDocumentReady(initModule);
whenResize(resizeModule);
function initModule() {
    // header height
    SetHeaderHeight();
    SetMegamenuHeight();
    wsForm();

    document.body.classList.add('paws-loaded');

    if (document.querySelector('.has-megamenu.is-active')) {
        document.querySelector('body').classList.add('expanded-megamenu');
    }
}

function resizeModule() {
    SetHeaderHeight();
    SetMegamenuHeight();
}


function SetHeaderHeight() {
    let headerHeight = 0;
    const header = document.querySelector('header');
    if (header) {
        headerHeight = header.offsetHeight;
    }

    const wpadminbar = document.querySelector('#wpadminbar');
    if (wpadminbar) {
        window.adminbarHeight = wpadminbar.offsetHeight;
        document.documentElement.style.setProperty('--paws-adminbar-height', wpadminbar.offsetHeight + 'px');
    }
    else {
        window.adminbarHeight = 0;
        document.documentElement.style.setProperty('--paws-adminbar-height', 0);
    }

    if (headerHeight < 1) {
        setTimeout(function() {SetHeaderHeight()}, 250);
    }

    window.headerHeight = headerHeight;
    document.documentElement.style.setProperty('--paws-header-height', headerHeight + 'px');
}

function SetMegamenuHeight() {
    let headerHeight = 0;
    const header = document.querySelector('.has-megamenu.is-active .megamenu');
    if (header) {
        headerHeight = header.offsetHeight;
    }

    if (headerHeight < 1) {
        setTimeout(function() {SetMegamenuHeight()}, 250);
    }

    document.documentElement.style.setProperty('--paws-megamenu-height', headerHeight + 'px');
}